var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"header-social"},_vm._l((_vm.config.socialnetworks),function(network,index){return _c('a',{key:index,attrs:{"href":network.url}},[_c('font-awesome-icon',{attrs:{"icon":['fab', network.icon]}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }